export default __webpack_public_path__ + "static/media/hcs.33693c58.png";